export const settingsDefault = {
  dice: {
    mute: true,
  },
};
